// @ts-nocheck
import { Operator, createOperator } from '../../core.ts'

// `.to(fn)` is the whole-value projection: every upstream change collapses
// to a single XU0 of `fn(source, prev)`. Useful for derived scalars (e.g.
// "is the array empty", "format this date as a string") where granular
// events would just be more code for the same observable answer. The
// reference-equality short-circuit means a `to` whose fn returns the same
// instance every time becomes a no-op subscription rather than a render
// storm — this is the contract that makes things like
// `filter.to(d => d?.length ? '' : 'none')` cheap.
export class ToValue extends Operator {
  constructor(p, fn) {
    super()
    this.p = p
    this.fn = fn
    this.XU0(this.p.value)
  }

  XU0(value) {
    const new_value = this.fn(value, this.view.value)
    if (new_value === this.view.value) return
    this.view.XU0(this.view.value = new_value)
  }
  XR0(){ this.XU0(this.p.value) }
  BR1(){ this.XU0(this.p.value) }
  BU1(){ this.XU0(this.p.value) }
  BI0(){ this.XU0(this.p.value) }
  BR2(){ this.XU0(this.p.value) }
  BU2(){ this.XU0(this.p.value) }
  BI2(){ this.XU0(this.p.value) }
}

export const to = (source, fn) => createOperator(source, ToValue, fn)
